/** Tuile QuickBooks — configuration partagée (statuts des factures, formats, chemins API). */
import { money } from "../../comptabilite/_shared";

export const qboBase = (masterId) => `/qbo/connections/${masterId}`;

export const QBO_STATUS = {
  open: { label: "Ouverte", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  overdue: { label: "En retard", cls: "bg-rose-100 text-rose-800 border-rose-200" },
  paid: { label: "Payée", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export const DOC_CFG = {
  invoices: { label: "Facture client", plural: "Factures clients", partyLabel: "Client", partyKind: "customers", balanceLabel: "À recevoir" },
  bills: { label: "Facture fournisseur", plural: "Factures fournisseurs", partyLabel: "Fournisseur", partyKind: "vendors", balanceLabel: "À payer" },
};

export const PARTY_CFG = {
  customers: { label: "Client", plural: "Clients", docs: "invoices", balanceLabel: "À recevoir" },
  vendors: { label: "Fournisseur", plural: "Fournisseurs", docs: "bills", balanceLabel: "À payer" },
};

/** Cellule de rapport : montant formaté si la colonne est numérique, texte sinon. */
export function fmtCell(v, numeric) {
  if (v === "" || v === null || v === undefined) return "";
  if (!numeric) return String(v);
  const n = Number(String(v).replace(/,/g, ""));
  return Number.isFinite(n) ? money(n) : String(v);
}

export const fmtDateTime = (iso) => (iso ? iso.slice(0, 16).replace("T", " ") : "—");
export const pct = (v) => `${Number(v || 0).toLocaleString("fr-CA", { maximumFractionDigits: 3 })} %`;
